import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAdminLoggedIn } from '../hooks/useAdminAuth';

const AdminRouteGuard = () => {
     const isAuthenticated = isAdminLoggedIn();

     // Si está autenticado, muestra el contenido de la ruta hija (Outlet).
     // Si no, lo redirige a la página de login.
     return isAuthenticated ? <Outlet /> : <Navigate to="/admin" replace />;
};

export default AdminRouteGuard;